export const SYNC_INPUT_HANDLE_CHANGE = "SYNC_INPUT_HANDLE_CHANGE";
export const SUBMIT_SYNC_INPUT = "SUBMIT_SYNC_INPUT";
export const SET_SELECTED_COLUMN = "SET_SELECTED_COLUMN";
